import React from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';

function YAxisSelect({ selectedY, onSelect }) {
  return (
    <div className="flex">
      <div className="text-muted m-r-16">Y-Axis</div>
      <ButtonToolbar style={{ width: '190px' }}>
        <DropdownButton
          id="percentage"
          bsStyle="info"
          title={selectedY ? 'Percentage' : 'Numerical'}
          className="btn-block text-capitalize"
          onSelect={(val) => onSelect({ percentage: val })}
          pullRight
        >
          <MenuItem active={!selectedY} eventKey={false}>
            Numerical
          </MenuItem>
          <MenuItem active={selectedY} eventKey>
            Percentage
          </MenuItem>
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default YAxisSelect;
